import { useState, useEffect } from "react";

export function useReferralLink(refCode) {
    const [referralLink, setReferralLink] = useState("");

    useEffect(() => {
        if (!refCode) return;

        const baseUrl = window.location.origin;
        setReferralLink(`${baseUrl}/r/${refCode}`);
    }, [refCode]);

    return referralLink;
}